/**
 * Log Service
 * Handles all system log-related API calls
 * @module services/logs/logService
 */

import httpClient from '@/utils/httpClient';
import { ENDPOINTS, getEndpointPath } from '@/api/endpoints';

const logService = {
  getAll: async (filters = {}) => {
    try {
      const response = await httpClient.get(getEndpointPath(ENDPOINTS.LOGS.BASE), { params: filters });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getStats: async () => {
    try {
      const response = await httpClient.get(getEndpointPath(ENDPOINTS.LOGS.STATS));
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  clear: async () => {
    try {
      const response = await httpClient.delete(getEndpointPath(ENDPOINTS.LOGS.CLEAR));
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  export: async (format = 'json') => {
    try {
      const endpoint = `${getEndpointPath(ENDPOINTS.LOGS.EXPORT)}?format=${format}`;
      const response = await httpClient.get(endpoint, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default logService;

